// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import DriverResponseController from "./driver_response_controller"
application.register("driver-response", DriverResponseController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)